























































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import { NotificationEventBus } from '@/EventBus';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import _ from 'lodash';
import moment from 'moment';
import Choices, { Choice } from '@/store/modules/Choices';
import { Decision } from '@/api/model/Decision';
import ListInputDialog from '@/components/forms/ListInputDialog.vue';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue'
import ChoiceVisibilityMenu from '@/components/choice-input/ChoiceVisibilityMenu.vue'
import Scoring from '@/store/modules/Scoring';
import Viewpoints from '@/store/modules/Viewpoints';
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ChoiceListSelection from  "@/components/Lists/ChoiceListSelection.vue"
import ChoiceListInputDialog from  "@/components/Lists/ChoiceListInputDialog.vue"
import ChoiceFileImporter from "@/views/ChoiceImport/ChoiceFileImporter.vue"
import ChoiceCreatorButton from "@/views/ChoiceManager/ChoiceCreatorButton.vue"
import Apps from '@/store/modules/Apps';
import CopyResourcesDialog from '@/components/common/CopyResourcesDialog.vue';

const appsModule = getModule(Apps);
const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const viewpointsModule = getModule(Viewpoints)
const WorkspaceOptionsModule = getModule(WorkspaceOptions);
const scoringModule = getModule(Scoring);

@Component({
    components: {
        ListInputDialog, 
        ChoiceInputDialog, 
        ChoiceVisibilityMenu, 
        ConfirmationDialog, 
        ChoiceListSelection,
        ChoiceListInputDialog, 
        ChoiceFileImporter, 
        ChoiceCreatorButton,
        CopyResourcesDialog
    },
})
export default class ChoiceCreator extends Vue {
    private refreshing = false;
    private addToList = false;
    private search = ""
    private showSearch = true;
    private selectedChoices = [];
    private showSelection = false;

    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;
    
    get isAdminOrOwner(): boolean {
        return decisionsModule.isAdmin || decisionsModule.isOwner;
    }

    get isDecisionOwner() {
        if (this.selectedDecision) {
            return this.currentUserId === this.selectedDecision.ownerUserId;
        }
    }

    get currentUserId() {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get editContent() {
        return WorkspaceOptionsModule.editContent;
    }

    get editComments() {
        return WorkspaceOptionsModule.editComments;
    }
    
    get headers() {
        return [
            {
                text: '',
                value: 'actions',
                sortable: false,
                width: 24,
            },
            {
                text: this.singularChoiceLabel,
                value: 'name',
                width: '25%',
            },
            {
                text: 'Updated',
                value: 'lastUpdatedTimestamp',
                width: 120,
            },
            {
                text: 'Created',
                value: 'creationTimestamp',
                width: 120,
            },
            {
                text: 'Owner',
                value: 'ownerUserId',
                width: 150,
            },
            {
                text: 'Score',
                value: 'id',
                width: 75,
                sort: (a:any, b: any) => {
                    if(this.getScoreForChoice(a) < this.getScoreForChoice(b)) {
                        return -1
                    }
                    if(this.getScoreForChoice(a) > this.getScoreForChoice(b)) {
                        return 1
                    }
                    else return 0 
                }
            },
            {
                text: 'Visibility',
                value: 'visibility',
                width: 75,
            },
            {
                text: 'Share Permissions',
                value: 'shareSetting',
                width: 150,
            },
        ];
    }

    get activeChoiceList(): string[] {
        return WorkspaceOptionsModule.activeChoiceLists;
    }

    get selectedDecision(): Decision {
        return decisionsModule.selectedDecision;
    }

    get choicesList(): Choice[] {
        return choicesModule.choicesList || [];
    }

    get activeViewpointId(): string {
        return viewpointsModule.activeViewpointId
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }
    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get scoringSuffix() {
        return decisionsModule.scoringSuffix
    }

    get userId(): string {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return '[user]';
    }

    get userList() {
        return decisionsModule.selectedDecisionUsers;
    }

    get decisionLists() {
        return decisionsModule.decisionLists
    }

    get choices() {
        return choicesModule.choices;
    }

    private editChoiceClick(item) {
        console.log(item)
    }

    private formatDate(dateString: string) {
        if (dateString === null) return '--';
        return moment(dateString).format('YYYY-MM-DD');
    }

    private getUserNameFromId(userId: string) {
        let user = decisionsModule.selectedDecisionUsers[userId];
        // console.log(user, userId);
        if(user){
            return user.first || user.last ? user.first + ' ' + user.last : user.email;
        } else{
            return 'Guest'
        }
    }

    private getTextFromShareSetting(shareSetting: string) {
        let shareOptions = [{name: 'View, Edit, Delete', id: "ALL"}, {name: 'Edit', id: "EDIT"}, {name: 'View', id: "VIEW"}]
        switch(shareSetting) {
            case 'EDIT': return 'Edit';
            case 'VIEW': return 'View';
            default: return 'View, Edit, Delete';
        }
    }

    private async createChoicesFromList(payload: any) {
        let list = payload.names;
        let addToList = _.clone(payload.addToList)
        if (list.length) {
            let choices = list.filter(l => l)
                .map(name => {
                    return {
                        name: name
                    } as Choice
                })
            this.refreshing = true;
            let newChoices = await choicesModule.createChoices(choices)
            if(addToList && newChoices) {
                for(let choice of Object.values(newChoices)) {
                    decisionsModule.addChoiceToActiveLists(choice.id)

                }
            }
            choicesModule.fetchChoices()
            this.refreshing = false;
        }
    }

    private getScoreForChoice(choiceId: string) {
        if(this.activeViewpointId && this.activeViewpointId in scoringModule.viewpointScores && choiceId in scoringModule.viewpointScores[this.activeViewpointId]?.choiceScores ) {
            return Math.ceil(scoringModule.viewpointScores[this.activeViewpointId]?.choiceScores[choiceId]?.score * 100)
        } else {
            return 0
        }

    }

    private async refresh() {
        this.refreshing = true;
        await choicesModule.fetchChoices();
        this.refreshing = false;   
    }

    @Watch('showSearch')
    private onChangeShowSearch() {
        this.search = "";
    }

    private canUserDelete(choice: any) {
        let usersModule = getModule(Users)

        //Owner of decision can always delete choices
        if(decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        if(choice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true
        }

        if(decisionsModule.isAdmin) {
            return true;
        }

        //Reaching here means user is not owner of choice or decision
        return !["VIEW", "EDIT"].includes(choice.shareSetting)

    }

    private async deleteChoice(choiceId: string) {
        this.refreshing = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.deleteChoice(choiceId);
            if(this.selectedChoices.length > 0) {
                let deletedIndex = this.selectedChoices.findIndex(choice => choice.id === choiceId)
                if(deletedIndex >= 0) 
                    this.selectedChoices.splice(deletedIndex, 1);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
        this.refreshing = false;
    }

    private async deleteMultiple() {

        this.refreshing = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            if(this.selectedChoices.length > 0) {
                await choicesModule.deleteMultiple(this.selectedChoices)
            
                if(WorkspaceOptionsModule.activeChoiceLists.length > 0) {
                    await decisionsModule.deleteChoiceFromList()
                }
            }
            NotificationEventBus.emitSuccessMessage();
        }
        catch(e) {
            NotificationEventBus.emitFailedMessage(e);
        }
        this.selectedChoices = [];
        this.showSelection = false;
        this.refreshing = false
        return
    
    }

    private async addToLists(payload: string[]) {
        console.log(payload)
        await decisionsModule.addChoicesToSelectLists({choices: this.selectedChoices, listIds: payload})
    }

    private async removeFromLists(payload: string[]) {
        console.log(payload)
        await decisionsModule.removeChoicesFromSelectLists({choices: this.selectedChoices, listIds: payload})
    }

    private loadSelection(payload: string[]) {
        let choicesInList: Choice[] = [];
        for(let listId of payload) {
            if(this.decisionLists[listId].type === 'CHOICE') {
                for(let choice of this.decisionLists[listId].choices) {
                    if( choice.choiceId in this.choices && !choicesInList.includes(this.choices[choice.choiceId]) ) {
                        choicesInList.push(this.choices[choice.choiceId]);
                    }
                }
            }
        }
        this.selectedChoices =  choicesInList;

    }

    @Watch('activeChoiceList')
    private onChangeActiveChoiceList() {
        this.selectedChoices = [];
    }

    private async copyChoices(payload: any) {
        this.refreshing = true;
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.copyMultipleChoices({choiceNameMapping: payload, addToList: this.addToList})
        } catch(err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        NotificationEventBus.emitSuccessMessage();
        this.refreshing = false;
        this.selectedChoices = [];
        
    }

}
